import React, { FC, memo } from "react"

import { Icon } from "src/components/common/icon"
import { Link } from "src/components/common/link"

import { create } from "src/helpers/bem"

import styles from "./DocumentBox.module.scss"

const bem = create(styles, "InfoBox")

export type DocumentBoxItem = {
  src: string | null
  name: string | null
}

export type DocumentBoxProps = {
  title?: string | null
  items: (DocumentBoxItem | null)[]
}

export const DocumentBox: FC<DocumentBoxProps> = memo(({ title, items }) => (
  <div className={bem()}>
    {title && <span className={bem("title")}>{title}</span>}
    <ul className={bem("items")}>
      {items &&
        items.map((item, i) => (
          <li key={`${i}-${item?.name}`} className={bem("item")}>
            <div className={bem("item__icon")}>
              <Icon
                className={bem("item__icon__image")}
                name="circleArrowRight"
              />
            </div>
            <Link
              href={item?.src ?? ""}
              target="_blank"
              classNames={{
                link: bem("item__link"),
                label: bem("item__label"),
              }}
            >
              {item?.name}
            </Link>
          </li>
        ))}
    </ul>
  </div>
))

DocumentBox.displayName = "DocumentBox"
